import classnames from 'classnames';
import React from 'react';
import { Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import BeXlist from '../data/BeXTable.json';
import A0538VR from "../images/A0538VR.png";
import A0538_orbits from "../images/A0538_orbits.png";
import A0538spectra from "../images/A0538_spectra_high.png";
import BeX from "../images/BeX.jpg";
import MCmaps from "../images/Mcs_HI_maps.jpg";
import SSSx from "../images/whitedwarf_stardisk.jpg";
import profile from "../profile";
import research from "../research";
import TableAndry from "./BeXTable";


class Research extends React.Component {
  constructor(props) {
        super(props);
    
        this.toggle = this.toggle.bind(this);
        this.state = {
          activeTab: '1'
        };
      }
    
    toggle(tab) {
    if (this.state.activeTab !== tab) {
        this.setState({
        activeTab: tab
        });
    }
    }

      render() {
        return <div>
          <Container>
            <Nav tabs>
              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '1' })}
                         onClick={() => { this.toggle('1'); }}>
                  High-Mass X-ray Binaries
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '2' })}
                         onClick={() => { this.toggle('2'); }}>
                  Supersoft X-ray Binaries
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '3' })}
                         onClick={() => { this.toggle('3'); }}>
                  Conferences
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: this.state.activeTab === '4' })}
                         onClick={() => { this.toggle('4'); }}>
                  Observations/Proposals
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                  <Hmxbs/>
              </TabPane>
              <TabPane tabId="2">
                <SSS/>
              </TabPane>
              <TabPane tabId="3">
                <ConfList/>
              </TabPane>
              <TabPane tabId="4">
                <Proposals/>
              </TabPane>                
            </TabContent>
          </Container>
        </div>;
      }
    }

    class Iframes extends React.Component {
      render() {
        return(         
            <div>          
              <iframe title="myFrame" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" style={{"--aspect-ratio":"1280/720"}} width={this.props.width} src={this.props.src} />          
            </div>
          )
        }
    }

    class Hmxbs extends React.Component {
        render() {
          return (
         <Container>
            <Row style={{margin:"35px 0px"}}>
              <Col md="3">
                <Row>
                  <Iframes src='https://www.youtube.com/embed/qVkKz2DOQjI?rel=1;&autoplay=1&mute=1&loop=1&playlist=qVkKz2DOQjI' width="100%"/>
                </Row>
                <Row>
                  <div style={{margin:"10px 0px"}}>
                  <img src={BeX} alt={BeX} width="100%"/>
                  </div>                     
                </Row>


              </Col>
              <Col md="9"> 
               <p>Be/X-ray binaries represent the largest sub-class of High-Mass X-ray binaries (80% of HMXBs). 
                   They consist of a compact object (usually an X-ray pulsar) orbiting an early-type non-supergiant 
                   Be star in a wide (orbital period around 10-300 days) and eccentric orbit. For reasons not fully 
                   understood, Be stars rotate very rapidly, leading to outflows from the Be star that form an equatorial
                   disc around it. If sufficiently extended, the neutron star (X-ray pulsar) can penetrate this equatorial 
                   disc during each periastron passage, giving rise to periodic outbursts that can be observed over a wide 
                   range of wavelengths (optical, X-ray,...)
                </p>
                <p>
                The mutual interactions between 
                the Magellanic Clouds and our own Galaxy have strongly influenced the physical properties of the Clouds, such as 
                their global morphology and their star-formation rate. HI radio observations of the southern
                sky revealed the existence of HI features, known as “the Magellanic Bridge”, the “Leading
                Arm”, and the “Magellanic Stream” that connect the Clouds and our Galaxy. These HI features are most likely a consequence 
                of gravitational interactions between the Clouds and the Milky Way.
                </p>
                <div style={{margin:"10px 0px", textAlign:"center"}}>
                  <img src={MCmaps} alt={MCmaps} width="50%"/>
                </div>    
              </Col>              
            </Row>
            <Row>
              <h3>Optical variations</h3>

            <ul className='list_period' style={{margin:"10px 0px"}}>
              <li> <b><em>Non-radial pulsation (NRP)</em></b> of the Be star: These periods are typically in
                the range 0.5-2 d with a V amplitude of up to 0.1 mag. Baade (1982) proposed that this modulation
                is due to non-radial pulsation. However, Balona (1990, 1995) attributed it
                to stellar spot, and later to corotating clouds. It has been confirmed that
                these periodic variation is related to non-radial pulsation of the Be star
                based on the detection of the true photospheric multi-periodicity.</li>
              <li>  <b><em>Orbital variation</em></b> : seen as regular outbursts which are related to the perias-
                tron passage of the neutron star perturbing the Be equatorial disc. Orbital periods are usually seen in the range of 10-500
                d. The strength of these outbursts varies significantly through the super-
                orbital cycle. They are very strong either at optical maxima or at optical
                minima, depending on the inclination of the source.</li>
              <li>  <b><em>V/R variations</em></b>: These are long-term cyclic changes in the ratio of the violet
                (V) and red (R) components of the observed emission line profiles in Be stars. It is widely accepted that these variations are caused by global one-
                armed oscillations in the equatorial discs of Be stars. For isolated Be stars, V/R variations are typically in the range of
                2-15 yrs (e.g. Papaloizou et al., 1992).</li>
              <li> <b><em>Very long-term superorbital variations</em></b> in the range of 300-3000 d which is
                suggested to be related to the formation and dissipation of the circumstellar
                disc around the Be star (Rajoelimanana et al., 2011)</li>
            </ul>
            <p>
              List of SMC X-ray pulsars <a href="https://ui.adsabs.harvard.edu/abs/2011MNRAS.413.1600R"> (Rajoelimanana et al., 2011)</a> showing the ID of the source in the MACHO and OGLE (II and III) archival databases, optical and X-ray properties.
            </p>
            </Row>
            <Row >
              <Col style={{padding:"10px 0px"}}>
                <TableBeX data={BeXlist}/>
              </Col>
            </Row>
            <Row>
            <h3 style={{margin:"10px 0px 20px 0px"}}> A0538-66: prototype of Be/X-ray binary <a style={{fontSize:"14px"}} href="https://ui.adsabs.harvard.edu/abs/2017MNRAS.464.4133R"> (Rajoelimanana et al., 2017)</a></h3>

            <p>
            Discovered as an X-ray transient more than 30 years ago, A0538-66 was quickly recognized as a remarkable object, with X-ray outbursts 
            recurring on a 16.6 d period, and 69 ms pulsations indicating a rapidly spinning neutron star. Its optical counterpart confirmed its 
            location in the Large Magellanic Cloud, and hence its peak X-ray luminosity was 10<sup>39</sup> erg s-1, substantially super-Eddington for a 1.4 M<sub>⊙</sub> neutron star,
            and still the highest in its class. Furthermore, the 15<sup>th</sup> mag B star counterpart was found to reach 12<sup>th</sup> mag during X-ray maximum, with
            optical/X-ray light curves that inferred a high orbital eccentricity, e > 0.7. This optical brightness increases is accompanied by the 
            appearance of He II λ4686 emission. 
            </p>
            <p>
            In <a href="https://ui.adsabs.harvard.edu/abs/2017MNRAS.464.4133R" >Rajoelimanana et al. (2017)</a>, we combine the decade long photometry of the Be/X-ray binary system A0538–66 provided by the <a href="http://macho.nci.org.au/" >MACHO</a> and <a href="http://ogle.astrouw.edu.pl/" >OGLE</a> projects with high resolution <a href="www.salt.ac.za" >SALT</a> spectroscopy
to provide detailed constraints on the orbital parameters and system properties of the system.
            </p>

            </Row>
            <Row style={{margin:"30px 0px"}}>
            <Col md="5">
              <img src={A0538VR} alt={A0538VR} width="100%"/>
              <div> <i>Evolution of the Hα line profile sorted in time sequence
(left) and by orbital phase (right). The dotted lines indicates the
rest velocity. Note the change in the line profiles from double-
peaked to singled-peak at periastron (φ = 0.038) and symmetric
shell profile far from periastron.</i></div>
            </Col>
            <Col md="7">
            <img src={A0538spectra} alt={A0538spectra} width="100%"/>
            <div> <i>Average high resolution spectra of A0538–66 in which all identified lines are marked. The spectrum of the B1 III star σ Sco (HD
147165) from Walborn & Fitzpatrick (1990) is also displayed for comparison. The gaps in the spectra are CCD gaps.</i></div>
            <img src={A0538_orbits} alt={A0538_orbits} width="100%"/>
            <div> <i>Geometry of the system, showing the relative orbit
of the NS around the Be star computed using our orbital solu-
tion. The coordinates are in units of the semimajor axis. Phase 0
is defined as the time when the outburst reaches its maximum
brightness. The phase of the periastron (square), the two optical
outburst peaks (circle) and the SALT observations (filled circle)
were marked. The dashed ellipse represents
the Roche lobe radius at each orbital phase for masses of M<sub>1</sub> =
8.84 M<sub>⊙</sub> and M<sub>X</sub> = 1.44 M<sub>⊙</sub> . The NS is moving counter-clockwise
around the Be star. We note that the figure is in scale.</i></div>
            </Col>
            </Row>
          </Container>
          )
        }
      }   



    function TableBeX(props) {
        const data = props.data;
        return(
            <TableAndry data={data}/>

        );
      }
  
    class SSS extends React.Component {
      render() {
        return (
        <Container>
          <Row style={{margin:"35px 0px"}}>
            <Col md="3">
              <Row>
                <Iframes src='https://www.youtube.com/embed/TB41r888GCI?rel=1;&autoplay=1&mute=1&loop=1&playlist=TB41r888GCI' width="100%"/>
              </Row>
              <Row>
                <div style={{margin:"10px 0px"}}>
                <img src={SSSx} alt={SSSx} width="100%"/>
                <div> <i>Image credit: NASA/CXC/M.Weiss</i></div>
                </div>                     
              </Row>
              
            </Col>
            <Col md="9"> 
              <p>Supersoft X-ray sources are white dwarf systems accreting matter from Roche-lobe filling donor at a rate close to or even exceeding the Eddington Limit.
              </p>
              <ul>
                <li style={{margin:"20px 0px"}}>
                  X-ray and optical properties of Magellanic Clouds Supersoft Sources<br />
                  <ul>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2013MNRAS.432.2886R">Rajoelimanana A.F., Charles P.A., Meintjes P.J., Odendaal A., Udalski A., 2013 </a><br /></li>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2014MNRAS.437.2948O">Odendaal A., Meintjes P.J., Charles P.A., Rajoelimanana A.F., 2014 </a><br /></li>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2017xru..conf..185R">Rajoelimanana A., Meintjes P., Charles P., 2017 </a><br /> </li>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2018cosp...42E.583C">Charles P., Maccarone T., Dewangan G.C., Buckley D., Odendaal A., Rajoelimanana A., 2018</a></li>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2015AcPPP...2...94O">Odendaal A., Meintjes P.J., Charles P.A., Rajoelimanana A.F., 2015</a><br /> </li>
                  </ul>
                </li>
                <li  style={{margin:"20px 0px"}}>
                  Be star with white dwarf as compact object.<br />
                  <ul>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2012ApJ...761...99L">Li K.L., Kong A.K..H., Charles P.A., Lu T., Bartlett E.S., Coe M.J., McBride V., Rajoelimanana A., 2012 </a></li>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2014ASPC..490..333M">McBride V.A., Li K.L., Kong A.K..H., Charles P.A., Lu T., Bartlett E.S., Coe M.J., Rajoelimanana A.</a></li>
                  </ul>
                </li>
                <li  style={{margin:"20px 0px"}}>
                  Origin of Supersoft X-Ray Emission From ASASSN-16oh<br />
                  <ul>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2019NatAs...3..173M"> 
                  Maccarone T.J., Nelson T.J., Brown P.J., Mukai K., Charles P.A., Rajoelimanana A., Buckley D.A..H., Strader J, 2018
                  </a><br /> </li>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2017heas.confE...3R">Rajoelimanana A., Meintjes P., Charles P., 2017</a><br /></li>
                  <li> <a href="https://ui.adsabs.harvard.edu/abs/2019HEAD...1711290M">
                  Maccarone T.J., Nelson T.J., Brown P., Mukai K., Charles P.A., Rajoelimanana A., Buckley D., Strader J., 2019
                  </a></li>
                  </ul>
                </li>
              </ul>

            </Col>              
          </Row>
        </Container>
        )
      }
    }   

    class ConfList extends React.Component {
      render() {
        return (
        <Container>
          <Row style={{margin:"25px 0px"}}>
            <Col>
              <ul>
              {profile.conference.map(function (conf, i){
                return(<li  style={{margin:"10px 0px"}} key={i}> {conf.conf}, {conf.conf_title}, {conf.type}, {conf.place}, {conf.date} </li>);
              })}
              </ul>


            </Col>
          </Row> 
        </Container> 
        );
    }
    }

    class Proposals extends React.Component {
      render() {
        return (
        <Container>
          <Row style={{margin:"25px 0px"}}>
            <Col>
              <ul>
                  <li style={{margin:"25px 0px"}}> <b>Optical spectroscopy</b>: <br />Extensive experience in spectroscopic observations, long-slit (SpCCD) and
  echelle (GIRAFFE) spectrograph using the <a href="https://www.saao.ac.za/explore/our-telescopes/">SAAO 1.9 m Telescope</a>, Sutherland (12 weeks with SpCCD and 1 week with GIRAFFE).
                </li>
                <li style={{margin:"25px 0px"}}> <b>Archival Observations</b> : <br />Expert in retrieval and analysis of large archival optical (<a href="http://macho.nci.org.au/">MACHO</a> and
<a href="http://ogle.astrouw.edu.pl/">OGLE</a>) and X-ray (<a href="https://heasarc.gsfc.nasa.gov/docs/xmm/xmm.html">XMM-Newton</a> and <a href="https://heasarc.gsfc.nasa.gov/docs/chandra/chandra.html">Chandra</a>) databases.
                </li>
                <li style={{margin:"25px 0px"}}> <b>Queue observations</b> : <br />I am the PI/PC/Co-I on various successfull SALT proposals.

                  <ul>
                  {research.queueObs.map(function (proposal, i){
                    return(<li  style={{margin:"10px 0px"}} key={i}> {proposal.title} [{proposal.type}] </li>);
                  })}
                  </ul>
                </li>
              </ul>

            </Col>
          </Row> 
        </Container> 
        );
    }
    }

export default Research;